import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, PhoneNumber } from "libphonenumber-js";

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(phoneValue: any ): any {
    var stringPhone  = phoneValue + '';
    const phoneNumber = parsePhoneNumber(stringPhone, 'US')
    const formatted = phoneNumber.formatNational()
    return formatted? formatted : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/phone.pipe.ts